
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { usePlans } from "@/hooks/usePlans";
import { UseFormReturn } from "react-hook-form";
import { DiscountFormValues } from "@/types/discount";

interface PlanSelectProps {
  form: UseFormReturn<DiscountFormValues>;
  selectedProductId: string;
}

export const PlanSelect = ({ form, selectedProductId }: PlanSelectProps) => {
  const { plans } = usePlans(selectedProductId);

  return (
    <FormField
      control={form.control}
      name="plan_id"
      render={({ field }) => (
        <FormItem>
          <FormLabel>Plan (Optional)</FormLabel>
          <Select
            onValueChange={field.onChange}
            value={field.value}
            disabled={!selectedProductId}
          >
            <FormControl>
              <SelectTrigger>
                <SelectValue 
                  placeholder={
                    selectedProductId 
                      ? "Select a plan" 
                      : "Select a product first"
                  } 
                />
              </SelectTrigger>
            </FormControl>
            <SelectContent>
              {plans.map((plan) => (
                <SelectItem key={plan.plan_id} value={plan.plan_id}>
                  {plan.plan_name}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
